exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3B84FUh-QQ94w1j41hTRf4{min-height:40px}", ""]);
// Exports
exports.locals = {
	"todo": "_3B84FUh-QQ94w1j41hTRf4"
};